@if (!evalAngular || evalAngular.length == 0) {
  <div [className]="collapse == true ? 'input-wrapper collapsed-side-form' : 'input-wrapper'"
    [id]="uId">
    <div class="side-info-table">
      <div class="side-wrapper edit-form-title-wrapper">
        <p class="input-form-title">{{translationsService.translate(title)}}</p>
      </div>
    </div>
    <div class="l-cont-separator">
    </div>
    <div class="html-js-content">
      <sem-loader [showLoader]="showLoader"></sem-loader>
    </div>
    <p class="inner-html-comp" [innerHtml]="innerHtml">
    </p>
  </div>
}

<!--button type="button" (click)="openVersion()">Odpri</button-->
@if (evalAngular && evalAngular.length > 0) {
  <div class="angular-eval">
    <span class="label-text">{{fieldTitle}}</span>
    <input
      [currencyMask]="{align: 'left', allowNegative: false, precision:2, min :0, inputMode : Natural, prefix:'', suffix : ' €', thousands: '.', decimal: ',' }"
      min="0" class="sem-text-box disabled-field" type="text" [disabled]="true" [ngModel]="getAngularEval()" />
    </div>
  }